// extracted by mini-css-extract-plugin
module.exports = {"SlideShowSlide":"_30khq","slideShowSlide":"_30khq","bg":"_1FJJ6","borderNode":"_2uaqg"};